import { render, staticRenderFns } from "./ModalNewSub.vue?vue&type=template&id=e8ac59f8&scoped=true"
import script from "./ModalNewSub.vue?vue&type=script&lang=js"
export * from "./ModalNewSub.vue?vue&type=script&lang=js"
import style0 from "./ModalNewSub.vue?vue&type=style&index=0&id=e8ac59f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ac59f8",
  null
  
)

export default component.exports